export const kansas = {
  "20000": "Kansas",
  "20001": "Allen County",
  "20003": "Anderson County",
  "20005": "Atchison County",
  "20007": "Barber County",
  "20009": "Barton County",
  "20011": "Bourbon County",
  "20013": "Brown County",
  "20015": "Butler County",
  "20017": "Chase County",
  "20019": "Chautauqua County",
  "20021": "Cherokee County",
  "20023": "Cheyenne County",
  "20025": "Clark County",
  "20027": "Clay County",
  "20029": "Cloud County",
  "20031": "Coffey County",
  "20033": "Comanche County",
  "20035": "Cowley County",
  "20037": "Crawford County",
  "20039": "Decatur County",
  "20041": "Dickinson County",
  "20043": "Doniphan County",
  "20045": "Douglas County",
  "20047": "Edwards County",
  "20049": "Elk County",
  "20051": "Ellis County",
  "20053": "Ellsworth County",
  "20055": "Finney County",
  "20057": "Ford County",
  "20059": "Franklin County",
  "20061": "Geary County",
  "20063": "Gove County",
  "20065": "Graham County",
  "20067": "Grant County",
  "20069": "Gray County",
  "20071": "Greeley County",
  "20073": "Greenwood County",
  "20075": "Hamilton County",
  "20077": "Harper County",
  "20079": "Harvey County",
  "20081": "Haskell County",
  "20083": "Hodgeman County",
  "20085": "Jackson County",
  "20087": "Jefferson County",
  "20089": "Jewell County",
  "20091": "Johnson County",
  "20093": "Kearny County",
  "20095": "Kingman County",
  "20097": "Kiowa County",
  "20099": "Labette County",
  "20101": "Lane County",
  "20103": "Leavenworth County",
  "20105": "Lincoln County",
  "20107": "Linn County",
  "20109": "Logan County",
  "20111": "Lyon County",
  "20113": "McPherson County",
  "20115": "Marion County",
  "20117": "Marshall County",
  "20119": "Meade County",
  "20121": "Miami County",
  "20123": "Mitchell County",
  "20125": "Montgomery County",
  "20127": "Morris County",
  "20129": "Morton County",
  "20131": "Nemaha County",
  "20133": "Neosho County",
  "20135": "Ness County",
  "20137": "Norton County",
  "20139": "Osage County",
  "20141": "Osborne County",
  "20143": "Ottawa County",
  "20145": "Pawnee County",
  "20147": "Phillips County",
  "20149": "Pottawatomie County",
  "20151": "Pratt County",
  "20153": "Rawlins County",
  "20155": "Reno County",
  "20157": "Republic County",
  "20159": "Rice County",
  "20161": "Riley County",
  "20163": "Rooks County",
  "20165": "Rush County",
  "20167": "Russell County",
  "20169": "Saline County",
  "20171": "Scott County",
  "20173": "Sedgwick County",
  "20175": "Seward County",
  "20177": "Shawnee County",
  "20179": "Sheridan County",
  "20181": "Sherman County",
  "20183": "Smith County",
  "20185": "Stafford County",
  "20187": "Stanton County",
  "20189": "Stevens County",
  "20191": "Sumner County",
  "20193": "Thomas County",
  "20195": "Trego County",
  "20197": "Wabaunsee County",
  "20199": "Wallace County",
  "20201": "Washington County",
  "20203": "Wichita County",
  "20205": "Wilson County",
  "20207": "Woodson County",
  "20209": "Wyandotte County",
};
